module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-3",
    attrs: {
      "id": "notfound"
    }
  }, [_c('div', {
    staticClass: "icon-notfound"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "50",
      "height": "50",
      "viewBox": "0 0 50 50"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icon_50_Notfound",
      "data-name": "Icon/50/Notfound",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Shape",
      "d": "M25,50A25,25,0,1,1,50,25,25.029,25.029,0,0,1,25,50ZM8.085,9.557A22.9,22.9,0,0,0,40.442,41.916ZM25,2.084a22.844,22.844,0,0,0-15.443,6L41.916,40.442A22.9,22.9,0,0,0,25,2.084Z",
      "transform": "translate(50 0) rotate(90)",
      "fill": "#acadb1"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('biblioSegment.noSearch')))]), _vm._v(" "), _c('h6', [_vm._v("\n      " + _vm._s(_vm.$t('biblioSegment.trySearch')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8491e26","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSegment/NotFoundCard.vue
// module id = 852
// module chunks = 1 3